import React from 'react';
import classNames from 'classnames';

import Loading from "../../shared/components/misc/Loading";
import RequirementItem from './RequirementItem';
import {segmentEventTracker} from "../../../utils/SegmentEventTracker";
import {TrackEventName} from "../../shared/constants/SegmentEvents";

const BTPRequirements = ({ ptp, btp, loading, onSubmit, push }) => {
  if (loading) return <div className="ds-card"><Loading /></div>;

  function isButtonDisabled() {
    return btp.information_status === 'rejected';
  }

  const containerClassName = () => {
    return classNames(
      'ds-card',
      {'-success': btp.are_all_requirements_pending_or_verified},
    );
  }

  const subheadClassName = () => {
    return classNames(
      'subhead _noBottomMargin',
      {'-success': btp.are_all_requirements_pending_or_verified},
    );
  }

  const submitButtonClassName = () => {
    return classNames(
      'ds-btn',
      '--full',
      {'_disabled': isButtonDisabled()},
    );
  }

  const btpProgress = () => {
    const total = 1;

    if (btp.incomplete_requirements_count === 0) {
      return <small className="byline _right -success">Completed</small>
    } else {
      return <small className="byline _right"> {Math.abs(btp.incomplete_requirements_count - total)} of {total} completed</small>
    }
  }

  const pushAction = (route, eventName) => {
    segmentEventTracker.trackEvent(eventName);
    push(route);
  };

  return (
    <div className={containerClassName()}>
      <section className="cardSection _withColumns _simple _noMinHeight">
        <h2 className={subheadClassName()}>Your Business Information</h2>
        {btpProgress()}
      </section>

      <RequirementItem
        status={ptp.information_status === 'draft' ? 'locked' : btp['information_status']}
        header="Complete Your Business info"
        onClick={ () => pushAction("/business_trustpass/information/new",
          TrackEventName.COMPLETE_BUSINESS_INFO_CLICKED)
        }
        dataTest='complete-business-info'
      />

      { !btp.are_all_requirements_pending_or_verified &&
          <a onClick={onSubmit}
            disabled={isButtonDisabled()}
            className={submitButtonClassName()}
          >
            Submit For Verification
          </a>
      }
    </div>
  );
};

export default BTPRequirements;



// WEBPACK FOOTER //
// ./src/features/home/components/BTPRequirements.js